import { createSlice } from '@reduxjs/toolkit';

import { User } from 'types/user';
import { resetStoresAction } from 'common/actions/common';

type AuthState<T> = {
  isFetching: boolean;
  user: T;
  error: string;
  message: string;
  isCaptchaEnabled?: boolean;
};

export type AuthPartialState<T = User> = {
  auth: AuthState<T>;
};

const defaultState: AuthState<any> = {
  isFetching: false,
  user: null,
  error: '',
  message: '',
  isCaptchaEnabled: false,
};

export const auth = createSlice({
  name: 'auth',
  initialState: defaultState,
  reducers: {
    loginSuccessAction: (state, { payload: { user } }) => ({
      ...state,
      user,
      isFetching: false,
    }),
    updateUserAction: (state, { payload }) => ({
      ...state,
      user: {
        ...state.user,
        ...payload,
      },
      isFetching: false,
    }),
    loginFailedAction: (state, { payload: { error, isCaptchaEnabled } }) => ({
      ...defaultState,
      error,
      isCaptchaEnabled,
    }),
    loginFetchingAction: (state, { payload: isFetching = true }) => ({
      ...state,
      isFetching,
    }),
    logoutFetchingAction: (state) => ({
      ...state,
      isFetching: true,
    }),
    onSetMessageAction: (state, { payload: message }) => ({
      ...state,
      message,
    }),
    logoutSuccessAction: () => defaultState,
    resetUserAuthAction: () => defaultState,
  },
  extraReducers: (builder) =>
    builder.addCase(resetStoresAction, () => defaultState),
});

export const {
  updateUserAction,
  loginSuccessAction,
  loginFailedAction,
  loginFetchingAction,
  logoutFetchingAction,
  logoutSuccessAction,
  resetUserAuthAction,
  onSetMessageAction,
} = auth.actions;

export default auth.reducer;
